import React from 'react';
import { object, string } from 'prop-types';
import LandingLink from './LandingLink';

/** The closing call to action. */
const FinalCta = props => {
  const { heading, text, link, label } = props;
  return (
    <section className="section-final-cta">
      <div className="container">
        <div className="section-head">
          <h2>{heading}</h2>
          <p>{text}</p>
        </div>
        <div style={{ textAlign: 'center' }}>
          <LandingLink className="btn btn-primary" link={link}>
            {label}
          </LandingLink>
        </div>
      </div>
    </section>
  );
};

FinalCta.propTypes = {
  heading: string.isRequired,
  text: string.isRequired,
  link: object.isRequired,
  label: string.isRequired,
};

export default FinalCta;
